import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import * as icons from "../../app/icons";


Vue.use(Vuetify);

import pt from 'vuetify/es5/locale/pt'
import colors from 'vuetify/es5/util/colors'

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {...icons}
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  theme: {
    themes: {
      light: {
        primary: '#3f51b5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
      dark: {
        primary: "#1565C0",
      },
    },
  },
});
